import {
  ADD_DRIVE_PROJECT_SUCCESS,
  ADD_DRIVE_PROJECT_FAIL,
  GET_DRIVE_PROJECT_SUCCESS,
  GET_DRIVE_PROJECT_FAIL,
  GET_DRIVE_PROJECTS_SUCCESS,
  GET_DRIVE_PROJECTS_FAIL,
  UPDATE_DRIVE_PROJECT_SUCCESS,
  UPDATE_DRIVE_PROJECT_FAIL,
  SET_DRIVE_PROJECT_LOADING,
  CLEAR_DRIVE_PROJECT_ERROR,
  DELETE_DRIVE_PROJECT_SUCCESS,
  DELETE_DRIVE_PROJECT_FAIL,
} from './types';

const initialState = {
  loading: false,
  project: null,
  projects: [],
  user: null
};

const driveReducer = function (state = initialState, action) {
  switch (action.type) {
    // this is for fetching loading time setter
    case SET_DRIVE_PROJECT_LOADING:
      return {
        ...state,
        loading: true,
      };

    case CLEAR_DRIVE_PROJECT_ERROR:
      return {
        ...state,
        error: null,
        updated: false,
        project: null,
      };

    case ADD_DRIVE_PROJECT_SUCCESS:
      return {
        ...state,
        project: action.payload,
        loading: false,
      };

    case GET_DRIVE_PROJECTS_SUCCESS:

      localStorage.setItem('centralize-dev-user-token', action.payload.token);
      localStorage.setItem('centralize-admin-token', action.payload.token);
      localStorage.setItem(
        'centralize-admin-data',
        JSON.stringify(action.payload.accessToken)
      );
      return {
        ...state,
        projects: action.payload.data,
        loading: false,
        user: action.payload.user
      };

    case GET_DRIVE_PROJECT_SUCCESS:
      localStorage.setItem(
        'centralize-admin-data',
        JSON.stringify(action.payload.accessToken)
      );
      localStorage.setItem('centralize-dev-user-token', action.payload.token);
      localStorage.setItem('centralize-admin-token', action.payload.token);

      return {
        ...state,
        project: action.payload.data,
        loading: false,
        user: action.payload.user
      };

    case UPDATE_DRIVE_PROJECT_SUCCESS:
    case DELETE_DRIVE_PROJECT_SUCCESS:
      return {
        ...state,
        project: action.payload,
        loading: false,
        updated: true,
        projects: state.projects.map((project) => {
          if (project._id === action.payload._id) {
            return action.payload;
          } else {
            return project;
          }
        }),
      };

    case GET_DRIVE_PROJECTS_FAIL:
    case GET_DRIVE_PROJECT_FAIL:
    case UPDATE_DRIVE_PROJECT_FAIL:
    case ADD_DRIVE_PROJECT_FAIL:
    case DELETE_DRIVE_PROJECT_FAIL:
      return {
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default driveReducer;
